<template>
  <div>
    <div class="plan-header">
      <div class="left-title" v-text="$t('report.title')"></div>
    </div>
    <div class="content-body">
      <div class="body">
        <div class="condition">
          <div class="form">
            <div class="demo-input-suffix">
              {{ $t('report.condition1') }}:
              <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="~" start-placeholder="" end-placeholder=""></el-date-picker>
            </div>
            <div class="demo-input-suffix">
              {{ $t('report.condition2') }}:
              <el-select v-model="form.plan_id" placeholder="" size="small" style="width: 160px; margin-left: 10px;">
                <el-option :label="$t('report.condition_label')" value=""></el-option>
                <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
              </el-select>
            </div>
            <div class="demo-input-suffix">
              {{ $t('report.condition3') }}:
              <el-select v-model="form.group_id" size="small" style="width: 160px; margin-left: 10px;">
                <el-option :label="$t('report.condition_label')" value=""></el-option>
                <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
              </el-select>
            </div>
            <div class="demo-input-suffix">
              {{ $t('report.condition4') }}:
              <el-select v-model="form.adv_id" size="small" style="width: 160px; margin-left: 10px;">
                <el-option :label="$t('report.condition_label')" value=""></el-option>
                <el-option :label="item.title" :value="item.adv_id" v-for="(item, index) in advLists" :key="index"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="search" size="small" v-text="$t('report.search_btn')"></el-button>

            <div style="margin: 20px 0;">

            </div>
            <div class="line-lists"></div>
          </div>
        </div>

        <div class="data-body">
          <div class="top-data">
            <div class="data-item blue">
              <div class="font" v-text="$t('report.item1')"></div>
              <div class="num" v-text="num['read_num']"></div>
            </div>
            <div class="data-item org">
              <div class="font" v-text="$t('report.item2')"></div>
              <div class="num" v-text="num['look_num']"></div>
            </div>
            <div class="data-item green">
              <div class="font" v-text="$t('report.item3')"></div>
              <div class="num" v-text="num['click_l']"></div>
            </div>
            <div class="data-item zs">
              <div class="font" v-text="$t('report.item4')"></div>
              <div class="num" v-text="num['click_p']"></div>
            </div>
            <div class="data-item red">
              <div class="font" v-text="$t('report.item5')"></div>
              <div class="num" v-text="num['pay_money']"></div>
            </div>
            <el-select v-model="form.value" placeholder="请选择" size="small" style="margin: 34px 0 0 360px;" @change="getData">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="make" style="margin-bottom: 50px;">
            <div id="myChart" :style="{width: '1622px', height: '374px'}"></div>
          </div>
          <div class="line-lists"></div>
          <div class="make" style="margin-top: 20px;">
            <!-- <el-button type="primary" size="small">下载报表</el-button> -->
          </div>
          <div class="table">
            <el-table :data="tableData" border style="width: 100%" size="small" :empty-text="$t('common.empty_text')" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
              <el-table-column prop="today" width="" :label="$t('report.td1')" align="center"></el-table-column>
              <el-table-column prop="read_num" sortable :label="$t('report.td2')" width="" align="center"></el-table-column>
              <el-table-column prop="look_num" sortable :label="$t('report.td3')" width="" align="center"></el-table-column>
              <el-table-column prop="click_l" sortable :label="$t('report.td4')" width="" align="center"></el-table-column>
              <el-table-column prop="cpc" sortable label="CPC" width="" align="center"></el-table-column>
              <el-table-column prop="cpm" sortable label="CPM" width="" align="center"></el-table-column>
              <el-table-column prop="pay_money" sortable :label="$t('report.td5')" width="" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      form: {
        status: '',
        type: '',
        plan_id: '',
        group_id: '',
        adv_id: '',
        pay_time: [],
        system: '',
        value: '2'
      },
      tableData: [],
      options: [{
        value: '2',
        label: this.$t('report.options1')
      }, {
        value: '1',
        label: this.$t('report.options2')
      }, {
        value: '6',
        label: this.$t('report.options3')
      }],
      num: [],
      planLists: [],
      groupLists: [],
      advLists: [],
      company_name: ''
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    this.setTimeInit();
    this.$http.post('/trader/index/getPlanPlusData').then(res => {
      if (res.code === 200) {
        this.planLists = res.data;
        this.getData();
      }
    });
  },
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 7);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.form.pay_time = [preToday, today];
    },
    getData() {
      this.$http.post('/trader/data/getTableLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.num = res.num;

          const option = {
            visualMap: [{
              show: false,
              type: 'continuous',
              seriesIndex: 0,
              min: 0,
              max: 400
            }],
            title: [{
              left: 'center',
              text: ''
            }],
            tooltip: {
              trigger: 'axis'
            },
            xAxis: [{
              data: res.static.data
            }],
            yAxis: [{
              splitLine: { show: false }
            }],
            grid: [{
              top: '8%',
              left: '5%',
              right: '5%',
              bottom: '12%'
            }],
            series: [{
              type: 'line',
              showSymbol: false,
              lineStyle: {
                color: res.color,
                width: 2
              },
              data: res.static.value
            }]
          };
          const echartsRecords = echarts.init(document.getElementById('myChart'), 'walden');
          echartsRecords.setOption(option);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.getData();
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/index/getGroupListsForPlanId', {
          plan_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.groupLists = res.data;
          }
        });
      } else {
        this.advLists = [];
      }
    },
    'form.group_id'(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/index/getAdvListsForGroupId', {
          group_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.advLists = res.data;
          }
        });
      } else {
        this.advLists = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .plan-header {
    width: calc(100% - 32px);
    padding: 0 16px;
    height: 48px;
    display: flex;
    flex-shrink: 0;
    background: #fff;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 66px;
    left: 0;
    background: #fff;
    z-index: 99;
    .left-title {
      line-height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #222;
    }
    .right-content {
      color: #666;
      font-size: 14px;
    }
  }
  .content-body {
    margin-top: 48px;
  }
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .line-lists {
    height: 6px;
    background-color: #f5f5f5;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1640px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 1645px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

  .data-body {
    clear: both;
    padding-top: 20px;
    .top-data {
      display: flex;
      margin: 10px 0 0 0;
      .data-item {
        width: 120px;
        height: 44px;
        padding: 11px 21px;
        color: #fff;
        margin-right: 20px;
        .font {
          font-size: 12px;
          margin-bottom: 5px;
        }
        .num {
          font-size: 22px;
        }
      }
      .blue {
        background: #4cc9f5;
      }
      .org {
        background: #ffc484;
      }
      .green {
        background: #28d7d2;
      }
      .zs {
        background: #c596f5;
      }
      .red {
        background: #ff749f;
      }
    }
    .table {
      margin: 20px 0 100px 0;
    }
  }

</style>
